import React, { useState } from 'react';
import { supabase } from '../../../services/supabaseClient';

const EditExperienceModal = ({ submissionId, experienceData, onClose, onSave }) => {
    const [formData, setFormData] = useState(experienceData || {});
    const [saving, setSaving] = useState(false);

    const handleSave = async () => {
        setSaving(true);
        try {
            const { error } = await supabase
                .from('wizard_submissions')
                .update({ experience_info: formData })
                .eq('id', submissionId);

            if (error) throw error;
            if (onSave) await onSave();
            onClose();
        } catch (err) {
            console.error('Error saving experience:', err);
            alert('Failed to save experience information');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                <div className="bg-gray-900/50 p-4 border-b border-gray-700 flex items-center justify-between sticky top-0">
                    <h3 className="text-lg font-bold text-white uppercase tracking-wider">Edit Work Experience</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-white"
                    >
                        ✕
                    </button>
                </div>

                <div className="p-6 space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Job Title</label>
                            <input
                                type="text"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.jobTitle || ''}
                                onChange={(e) => setFormData({ ...formData, jobTitle: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Company</label>
                            <input
                                type="text"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.company || ''}
                                onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Total Experience</label>
                            <input
                                type="text"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.totalExperience || ''}
                                onChange={(e) => setFormData({ ...formData, totalExperience: e.target.value })}
                                placeholder="e.g., 5 years"
                            />
                        </div>

                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Industry</label>
                            <input
                                type="text"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.industry || ''}
                                onChange={(e) => setFormData({ ...formData, industry: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Start Date</label>
                            <input
                                type="date"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.startDate || ''}
                                onChange={(e) => setFormData({ ...formData, startDate: e.target.value })}
                            />
                        </div>

                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">End Date</label>
                            <input
                                type="date"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.endDate || ''}
                                onChange={(e) => setFormData({ ...formData, endDate: e.target.value })}
                                disabled={formData.currentlyWorking}
                            />
                        </div>

                        <div>
                            <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Location</label>
                            <input
                                type="text"
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                                value={formData.location || ''}
                                onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                            />
                        </div>

                        <div className="flex items-center pt-6">
                            <label className="flex items-center gap-2 text-sm text-gray-300">
                                <input
                                    type="checkbox"
                                    checked={formData.currentlyWorking || false}
                                    onChange={(e) => setFormData({ ...formData, currentlyWorking: e.target.checked, endDate: e.target.checked ? '' : formData.endDate })}
                                    className="rounded border-gray-600 bg-gray-900"
                                />
                                Currently Working
                            </label>
                        </div>
                    </div>

                    <div>
                        <label className="block text-xs text-gray-400 uppercase tracking-wider mb-1">Description</label>
                        <textarea
                            className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white"
                            rows="4"
                            value={formData.description || ''}
                            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                            placeholder="Job responsibilities and achievements..."
                        />
                    </div>

                    <div className="flex gap-3 justify-end mt-6 pt-4 border-t border-gray-700">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 rounded text-sm font-bold bg-gray-700 text-white hover:bg-gray-600 border border-gray-600"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleSave}
                            disabled={saving}
                            className="px-4 py-2 rounded text-sm font-bold bg-blue-600 text-white hover:bg-blue-700 border border-blue-500 disabled:opacity-50"
                        >
                            {saving ? 'Saving...' : 'Save Changes'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditExperienceModal;
